import SubLabel from "components/Atoms/Sublabel";
import { GooglePlaceInputValue } from "components/ValidatedFields/GooglePlaceInput";
import React from "react";
import { RemovableLabel, RemovableProps } from "./Removable";

const RemovableGooglePlace = (props: RemovableProps<GooglePlaceInputValue>) => {
  return <RemovableLabel {...props}>
    <div>
      <div>{props.value.name}</div>
      <SubLabel>{props.value.address}</SubLabel>
    </div>
  </RemovableLabel>
};

export default RemovableGooglePlace;